import React, {useState} from 'react';

import ContextMenu from '../../../../shared-components/custom-features/contextmenu/ContextMenu';
import {RowActions} from './RowActions';

/**
 * If you right-click anywhere in the table, this component will open a context menu. It will look up which cell you
 * right-clicked on, and show the appropriate options for that cell.
 * @param outerRef A ref to the table (or wrapper of the table) on which we will register a right-click listener
 * @param rows All rows rendered in the table (the rows object as prepared by EntityTable)
 * @param entityType The entity type of the displayed rows
 * @param t Translation function
 * @returns {Element} Null when the menu is closed, otherwise an automatically positioned context menu
 */
const TableTooltip = ({outerRef, rows, entityType, t}) => {
    const [clickedCell, setClickedCell] = useState(null);

    // When the menu opens, we get the right click event, which will tell us what cell was right-clicked.
    // Based on this cell,we can look up the row and column, which can then get us the entity ID and all the
    // other stuff we need to fill the menu
    const onMenuOpen = (ev) => {
        const td = ev.target.closest('td');
        const tr = ev.target.closest('tr');

        if (tr && td) {
            if ('columnId' in td.dataset && 'rowId' in tr.dataset) {
                const colIx = +td.dataset['columnId'];
                const rowIx = +tr.dataset['rowId'];

                const cell = rows[rowIx].columns[colIx];

                setClickedCell({row: rows[rowIx], cell});
            } else {
                setClickedCell(null);
            }
        }
    };

    return (
        <ContextMenu outerRef={outerRef} onOpen={onMenuOpen}>
            {clickedCell?.cell.filterOnField && (
                <ContextMenu.Section>
                    <ContextMenu.Item
                        icon="filterAlt"
                        label={t('generalShared.filter', {columnName: clickedCell?.cell.columnInfo.displayName})}
                        onClick={clickedCell.cell.filterOnField}
                    />
                </ContextMenu.Section>
            )}
            {clickedCell && (
                <RowActions
                    entityId={clickedCell.row.entityId}
                    rowPeek={clickedCell.row.rowPeek}
                    entityType={entityType}
                    t={t}
                />
            )}
        </ContextMenu>
    );
};

export default TableTooltip;
